module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/pc/profile_page/profile_image-c6b373b6d471131b5ecda8d809b2f6cf.png";